import React from 'react';
interface BreatherProps {
  src: string;
  alt: string;
}
export function Breather({
  src,
  alt
}: BreatherProps) {
  return <div className="h-[32vh] min-h-[220px] w-full overflow-hidden md:h-[46vh]" data-id="element-33" data-mp="3biiixd6rxdnq">
      <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" data-id="element-34" data-mp="3gfsk1q3izdre" />
    </div>;
}